import 'index.css';
import BottomBarContainer from 'containers/BottomBarContainer';
import TopBarContainer from 'containers/TopBarContainer';
import React, { FC, PropsWithChildren } from 'react';
import { useDarkMode } from 'hooks/useDarkMode';
import InitialWalletModal from 'common/components/InitialWalletModal/InitialWalletModal';

const Index: FC<PropsWithChildren> = ({ children }) => {
  const darkMode = useDarkMode();
  return (
    <>
      <div className="pb-24">
        <div className="flex flex-col w-full items-center styled-content">
          <TopBarContainer toggleTheme={darkMode.toggle} />
          <div className="w-full max-w-7xl pl-4 pr-4 sm:pl-10 sm:pr-10">
            {children}
          </div>
        </div>
        <BottomBarContainer />
      </div>
      <InitialWalletModal />
    </>
  );
};

export { Head } from './common/components/seo';

export default Index;
